import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError, tap, switchMap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";

import { IConfiguration } from "../interfaces/iconfiguration";
import { BaseService } from "./base.service";

@Injectable()
export class ConfigurationService {
    constructor(private httpClient: HttpClient) {}

    getLoginUrl(): Observable<string> {
        return this.httpClient.get("/api/configuration")
            .pipe(map((res: any) => {
                const configuration: IConfiguration = res as IConfiguration;
                return "https://login.microsoftonline.com/" +
                    configuration.azureConfig.tenant + "/oauth2/authorize?" +
                    "response_type=id_token&" +
                    "response_mode=fragment&" +
                    `client_id=${configuration.azureConfig.clientId}&` +
                    `redirect_uri=${configuration.azureConfig.postLoginRedirectUrl}&` +
                    "scope=openid&" +
                    "nonce=" + this.getNonce(32);
            }));
    }

    private getNonce(length: number): string {
        let text: string = "";
        let possible: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let array = new Uint32Array(1);
        for (let i: number = 0; i < length; i++) {
            window.crypto.getRandomValues(array);
            let random = array[0] / (0xffffffff + 1);
            text += possible.charAt(Math.floor(random * possible.length));
        }
        return text;
    }
}


